import { render, staticRenderFns } from "./CustomerSideMenu.vue?vue&type=template&id=0da0dd8a"
import script from "./CustomerSideMenu.vue?vue&type=script&lang=js"
export * from "./CustomerSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports